<template>
    <v-progress-linear slot="progress" color="primary" indeterminate v-if="loadingData"></v-progress-linear>
    <v-container v-else class="release-certificate-container" style="width: 60%;">
        <v-card class="release-certificate-card">
            <v-btn
                color="info"
                class="release-certificate-print-button"
                @click="print"
            >
                Print
            </v-btn>
            <v-row class="header pl-5 text-left" no-gutters>
                <v-col cols="12"> 
                    <h3 class="no-gutter-col">BTG Pharmaceuticals, Inc.</h3>
                </v-col>
                <v-col cols="12">
                    <h3 class="no-gutter-col">UTAH Venom Research Lab</h3>
                </v-col>
                <v-col cols="12">
                    <p class="no-gutter-col">BSC/BTG-UTAH</p>
                </v-col>
                <v-col cols="12">
                    <p class="no-gutter-col">615 Arapeen Drive, Suite 105</p>
                </v-col>
                <v-col cols="12">
                    <p class="no-gutter-col">Salt Lake City, Utah 84108</p>
                </v-col>
                <v-col cols="12">
                    <p class="no-gutter-col">TM: +1 801 913 4799 TO: +1 801 583 8077 X1</p>
                </v-col>
                <v-col cols="12">
                    <p class="no-gutter-col">richard.straight@btgsp.com</p>
                </v-col>
                <v-col cols="12">
                    <a href="info@btgsp.com">info@btgsp.com</a><p class="no-gutter-col">www.btgsp.com</p>  
                </v-col>      
            </v-row>
            <v-divider> </v-divider>
            <h2 class="text-center">Certificate of Analysis</h2>
            
            <v-row class="release-certificate-row" dense>
                <v-col cols="12" class="text-center" v-if="loadError">
                    <v-alert outlined :value="true" color="error" icon="error">
                        {{loadError}}
                    </v-alert>
                </v-col>
                <v-col cols="12" lg="6" offset-lg="3">
                    <v-row class="text-center">
                        <v-col cols="12">
                            <h6>Venom reference for CroFab: CroFab PLA 98-0507-003</h6>
                        </v-col>
                    </v-row>
                    <ReleaseCertificateDatumRow
                        label="Protocol Reference"
                        fontWeight="font-weight-black"
                        value="UTA-SP-12.001 - Venom Collection, Pooling and Certification">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Venom Source"
                        fontWeight="font-weight-black"
                        value="BTG/SP-Utah">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Lot Number(s)"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :arrayValue="(venomLot.QALotNumbers || '').split(', ')">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Batch Number(s)"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :arrayValue="venomLot.SpeciesBatchPools.map(sbp => sbp.Barcode)">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Quantity"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.TotalWeight + 'g'">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Color / Appearance"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.QAAppearance">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="RP-HPLC STD. PROTOCOL ANALYSIS"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.QAProtocolAnalysis">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Result"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.QAResult">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Purity"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        value="Conforms to Standard">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Quality"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.QAQuality">
                    </ReleaseCertificateDatumRow>
                    <ReleaseCertificateDatumRow
                        label="Comments"
                        fontWeight="font-weight-bold"
                        backgroundColor="yellow"
                        :value="venomLot.QAComments">
                    </ReleaseCertificateDatumRow>

                    <div class="approve-card pt-2">
                        <v-row v-if="imagePath" class="pl-5">
                            <v-col cols="12">
                                <h4 fontWeight="font-weight-black">
                                    Approved By and Date:
                                </h4>
                                <v-img :src="imagePath" width="250px" height="40px"> </v-img>
                            </v-col>
                        </v-row>

                        <ReleaseCertificateDatumRow
                            v-else
                            label="Approved By:"
                            fontWeight="font-weight-black"
                            backgroundColor="yellow"
                            :value="`${venomLot.ClosedByFullName} (${venomLot.ClosedByEmail})`">
                        </ReleaseCertificateDatumRow>

                        <ReleaseCertificateDatumRow
                            label="Date:"
                            fontWeight="font-weight-black"
                            backgroundColor="yellow"
                            :value="$moment.utc(venomLot.ClosedTime).local().format($constants.DATE_FORMAT_NO_TIME)">
                        </ReleaseCertificateDatumRow>
                    </div>

                </v-col>
            </v-row>

        </v-card>
    </v-container>
</template>

<script>

import util from '@/helpers/util';
import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import fileService from "../../services/fileService";
import constants from 'comunet-btg-utah-repository-shared/constants';
import exports from "@/services/export";


import moment from 'moment';

import ReleaseCertificateDatumRow from "@/components/venompooling/ReleaseCertificateDatumRow.vue";

export default {
    components: {
        ReleaseCertificateDatumRow
    },
    props: {
        
    },
    data() {
        return {
            loadingData: true,
            venomLot: {},
            imagePath:"",
            loadError: null,
    
        }
    },
    computed: {
        venomLotID() {
            return this.$route.params.venomLotID;
        },
    },
    methods: {
        async loadData() {
            this.loadingData = true;

            try {
                this.venomLot = await VenomPoolingAPI.getVenomLots({ venomLotID: this.venomLotID });
            }
            catch (e) {
                this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            finally {
                this.loadingData = false;
            }
        },
         async loadImageS3Path(){
            this.loadingData = true;

            const email = this.venomLot.ClosedByEmail;
            
            try{
                
                const S3Path = await fileService.getImageS3Path(email);
                this.$store.state.authStore.user.UserProfile.ImageS3Path = S3Path.ImageS3Path;
            }
            catch(e){
                 this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            this.loadingData = false;
        },
        async loadImage() {
            this.loadingData = true;
            const imageS3Path = this.$store.state.authStore.user.UserProfile.ImageS3Path;

            try{
                var filePath = await fileService.getDownloadURL(imageS3Path);
            }
            catch (e) {
                this.loadError = e;

                // eslint-disable-next-line no-console
                console.log(e);
            }
            this.imagePath = filePath;
            this.loadingData = false;
        },
        print() {
            window.print();
        }
    },
    watch: {
        
    },
    async created() {
        await this.loadData();
        await this.loadImageS3Path();
        await this.loadImage();
    }
}
</script>

<style lang="scss" scoped>
    #app {
        .release-certificate-print-button {
            position: absolute;
            right: 10px;
        }

        .release-certificate-card{
            background-image: url("../../assets/img/template_logo.png");
            background-size: 100% 100%;
            background-position: center;
            font-family: Arial;
            text-transform: uppercase;
            color: blue($color: #7b8fa1) !important;
        }

        .no-gutter-col{
            padding: 0;
            margin: 0;
        }
        .header {
            margin-top: 134px;
            font-size: 12px;
        }
        .approve-card{
            background-color:#b6d8de;
        }

        @media print {
            .release-certificate-container {
                /* the v-card that all the content is in will not stretch out to the entire page when printing without these styles */
                .v-card {
                    border-radius: 0px;
                    height: 100%;
                    position: absolute;
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    right: 0px;
                }
            }
        }
    }
</style>